export const motivosForSucursalDepartamento = (motivos, formik) =>
  motivos && formik.values.sucursaldepartamentoAsignado
    ? motivos
        // Filtro los motivos de esa sucursal / departamento
        .filter(
          (motivo) =>
            (motivo.DeptosucursalCasaCentral && motivo.DeptosucursalCasaCentral.map((item) => item.itemId).includes(formik.values.sucursaldepartamentoAsignado)) ||
            (motivo.DeptosucursalSucursales && motivo.DeptosucursalSucursales.map((item) => item.itemId).includes(formik.values.sucursaldepartamentoAsignado))
        )
    : [];
